import { Container, Row } from "react-bootstrap";
import Leftmenubar from "./Components/Left_menubar";
import Displayshops from "./Components/Display_shops";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useLazyGetUserCompaniesQuery } from "../../features/user/userApiSlice";
import { useLazyGetUserShopsByBusinessTypeQuery } from "../../features/shop/shopApiSlice";
import { useLazyGetServicesByUserAndCategoryQuery } from "../../features/service/serviceApiSlice";

const BusinessDashboard = () => {
  const [companyData, setCompanyData] = useState();
  const [newitemraw, setNewitemraw] = useState();
  const [newitemfinish, setNewitemfinish] = useState();
  const [newitemmanufacture, setNewitemmanufacture] = useState();
  const [newitemwhole, setNewitemwhole] = useState();
  const [newitemretailer, setNewitemretailer] = useState();
  const [homemaderaw, setHomemaderaw] = useState();

  const [seconditem, setSeconditem] = useState();
  const [showdata, setShowdata] = useState();
  const [mineralraw, setMineralraw] = useState();
  const [mineralfinish, setMineralfinish] = useState();
  const [mineralmanufacture, setMineralmanufacture] = useState();
  const [mineralwhole, setMineralwhole] = useState();
  const [mineralretailer, setMineralretailer] = useState();
  const [serviceit, setServiceit] = useState();
  const [servicetraining, setServicetraining] = useState();
  const [consultingservice, setConsultingservice] = useState();
  const [marketingservice, setMarketingservice] = useState();
  const [constructionservice, setConstructionservice] = useState();
  const [wasteservices, setWasteservices] = useState();
  const [legalservice, setLegalservice] = useState();
  const [healthservice, setHealthservice] = useState();
  const [securityservice, setSecurityservice] = useState();
  const [travelservices, setTravelservices] = useState();
  const [researchservice, setResearchservice] = useState();
  const [financeservices, setFinanceservices] = useState();
  const [deliveryservices, setDeliveryservices] = useState();
  const [childcareservices, setChildcareservices] = useState();
  const [personalservices, setPersonalservices] = useState();

  const { name } = useSelector((state) => state.user);

  const [getCompanies] = useLazyGetUserCompaniesQuery();
  const [getShops] = useLazyGetUserShopsByBusinessTypeQuery();
  const [getServices] = useLazyGetServicesByUserAndCategoryQuery();

  const Getdata = async () => {
    setShowdata(1);
    try {
      const res = await getCompanies({
        userid: name._id,
        businessType: "company",
      }).unwrap();
      setCompanyData(res?.data?.Companies);
    } catch (err) {}
  };

  const Newitemdataraw = async () => {
    setShowdata(2);
    try {
      const res = await getShops({
        userid: name._id,
        businessType: "newShop",
      }).unwrap();
      setNewitemraw(res?.data?.Shops);
    } catch (err) {}
  };

  const Newitemdatasupplier = async () => {
    setShowdata(3);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Finished Raw Materials",
        businessType: "newShop",
      }).unwrap();
      setNewitemfinish(res?.data?.Shops);
    } catch (err) {}
  };

  const Newitemdatamanufacture = async () => {
    setShowdata(4);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Manufacturer",
        businessType: "newShop",
      }).unwrap();
      setNewitemmanufacture(res?.data?.Shops);
    } catch (err) {}
  };

  const Newitemdatawholesaler = async () => {
    setShowdata(5);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Wholeseller",
        businessType: "newShop",
      }).unwrap();
      setNewitemwhole(res?.data?.Shops);
    } catch (err) {}
  };

  const Newitemdataretailer = async () => {
    setShowdata(6);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Retailer",
        businessType: "newShop",
      }).unwrap();
      setNewitemretailer(res?.data?.Shops);
    } catch (err) {}
  };

  const Secondhanditem = async () => {
    setShowdata(7);
    try {
      const res = await getShops({
        userid: name._id,
        businessType: "oldShop",
      }).unwrap();
      setSeconditem(res?.data?.Shops);
    } catch (err) {}
  };

  const Homemaderaw = async () => {
    setShowdata(8);
    try {
      const res = await getShops({
        userid: name._id,
        businessType: "homeShop",
      }).unwrap();
      setHomemaderaw(res?.data?.Shops);
    } catch (err) {}
  };

  const Mineralraw = async () => {
    setShowdata(13);
    try {
      const res = await getShops({
        userid: name._id,
        businessType: "gemsShop",
      }).unwrap();
      setMineralraw(res?.data?.Shops);
    } catch (err) {}
  };

  const Mineralfinish = async () => {
    setShowdata(14);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Finished Raw Materials",
        businessType: "gemsShop",
      }).unwrap();
      setMineralfinish(res?.data?.Shops);
    } catch (err) {}
  };

  const Mineralmanufacture = async () => {
    setShowdata(15);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Manufacturer",
        businessType: "gemsShop",
      }).unwrap();
      setMineralmanufacture(res?.data?.Shops);
    } catch (err) {}
  };

  const Mineralwhole = async () => {
    setShowdata(16);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Wholeseller",
        businessType: "gemsShop",
      }).unwrap();
      setMineralwhole(res?.data?.Shops);
    } catch (err) {}
  };

  const Mineralretailer = async () => {
    setShowdata(17);
    try {
      const res = await getShops({
        userid: name._id,
        businessCategory: "Retailer",
        businessType: "gemsShop",
      }).unwrap();
      setMineralretailer(res?.data?.Shops);
    } catch (err) {}
  };

  const Serviceit = async () => {
    setShowdata(18);
    try {
      const res = await getServices({ userid: name._id }).unwrap();
      setServiceit(res?.data?.Services);
    } catch (err) {}
  };

  const ServiceTraining = async () => {
    setShowdata(19);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Training services",
      }).unwrap();
      setServicetraining(res?.data?.Services);
    } catch (err) {}
  };

  const Consultingservices = async () => {
    setShowdata(20);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Consulting services",
      }).unwrap();
      setConsultingservice(res?.data?.Services);
    } catch (err) {}
  };

  const Marketingservices = async () => {
    setShowdata(21);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Marketing services",
      }).unwrap();
      setMarketingservice(res?.data?.Services);
    } catch (err) {}
  };

  const Constructionservices = async () => {
    setShowdata(22);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Construction services",
      }).unwrap();
      setConstructionservice(res?.data?.Services);
    } catch (err) {}
  };

  const Wastemanagementservices = async () => {
    setShowdata(23);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Waste management services",
      }).unwrap();
      setWasteservices(res?.data?.Services);
    } catch (err) {}
  };

  const Legalservices = async () => {
    setShowdata(24);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Legal services",
      }).unwrap();
      setLegalservice(res?.data?.Services);
    } catch (err) {}
  };

  const Healthservice = async () => {
    setShowdata(25);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Health and wellness services",
      }).unwrap();
      setHealthservice(res?.data?.Services);
    } catch (err) {}
  };

  const Securityservices = async () => {
    setShowdata(26);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Security services",
      }).unwrap();
      setSecurityservice(res?.data?.Services);
    } catch (err) {}
  };

  const Travelservices = async () => {
    setShowdata(27);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Travel services",
      }).unwrap();
      setTravelservices(res?.data?.Services);
    } catch (err) {}
  };

  const Researchservices = async () => {
    setShowdata(28);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Research services",
      }).unwrap();
      setResearchservice(res?.data?.Services);
    } catch (err) {}
  };

  const Financeservices = async () => {
    setShowdata(29);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Finance services",
      }).unwrap();
      setFinanceservices(res?.data?.Services);
    } catch (err) {}
  };

  const Deliveryservices = async () => {
    setShowdata(30);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Delivery services",
      }).unwrap();
      setDeliveryservices(res?.data?.Services);
    } catch (err) {}
  };

  const Childcareservices = async () => {
    setShowdata(31);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Child care services",
      }).unwrap();
      setChildcareservices(res?.data?.Services);
    } catch (err) {}
  };

  const Personalservices = async () => {
    setShowdata(31);
    try {
      const res = await getServices({
        userid: name._id,
        category: "Personal services",
      }).unwrap();
      setPersonalservices(res?.data?.Services);
    } catch (err) {}
  };

  return (
    <>
      <Container fluid className="ps-0">
        <Row>
          <Leftmenubar
            Getdata={Getdata}
            setShowdata={setShowdata}
            Newitemdataraw={Newitemdataraw}
            Secondhanditem={Secondhanditem}
            Homemaderaw={Homemaderaw}
            Mineralraw={Mineralraw}
            Serviceit={Serviceit}
            ServiceTraining={ServiceTraining}
            Consultingservices={Consultingservices}
            Marketingservices={Marketingservices}
            Constructionservices={Constructionservices}
            Wastemanagementservices={Wastemanagementservices}
            Legalservices={Legalservices}
            Healthservice={Healthservice}
            Securityservices={Securityservices}
            Travelservices={Travelservices}
            Researchservices={Researchservices}
            Financeservices={Financeservices}
            Deliveryservices={Deliveryservices}
            Childcareservices={Childcareservices}
            Personalservices={Personalservices}
          />
          <Displayshops
            url="/business-dashboard"
            companyData={companyData}
            showdata={showdata}
            newitemraw={newitemraw}
            newitemfinish={newitemfinish}
            newitemmanufacture={newitemmanufacture}
            newitemwhole={newitemwhole}
            newitemretailer={newitemretailer}
            seconditem={seconditem}
            homemaderaw={homemaderaw}
            Newitemdataraw={Newitemdataraw}
            mineralraw={mineralraw}
            mineralfinish={mineralfinish}
            mineralmanufacture={mineralmanufacture}
            mineralwhole={mineralwhole}
            mineralretailer={mineralretailer}
            serviceit={serviceit}
            servicetraining={servicetraining}
            consultingservice={consultingservice}
            marketingservice={marketingservice}
            constructionservice={constructionservice}
            wasteservices={wasteservices}
            legalservice={legalservice}
            healthservice={healthservice}
            securityservice={securityservice}
            travelservices={travelservices}
            researchservice={researchservice}
            financeservices={financeservices}
            deliveryservices={deliveryservices}
            childcareservices={childcareservices}
            personalservices={personalservices}
          />
        </Row>
      </Container>
    </>
  );
};

export default BusinessDashboard;
